import { Image } from "antd";
import { LeadFormDialog } from "./LeadFormDialog";
import { useTranslation } from "react-i18next";
import LanguageSwitcher from "../language-switcher";
import { useState } from "react";
import { Link } from "react-router-dom";
import { routes } from "../../Routes";

export const Header = ({utms}) => {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-background/80 backdrop-blur-md border-b border-border">
      <div className="container mx-auto px-4 py-3 md:py-4 flex items-center justify-between">
        <div className="flex items-center">
          <Link to={routes.cashierlandingPage}>
            <Image
              src={require("../../assets/Logo/logo.png")}
              alt="myGINNE logo"
              width={120}
              height={40}
              preview={false}
              className="cursor-pointer hover:opacity-90 transition"
            />
          </Link>
        </div>
        <div className="flex flex-row items-center">
          <LanguageSwitcher loading={loading} setLoading={setLoading} />
          <LeadFormDialog utms={utms}>
            <button className="px-4 sm:px-6 py-2 bg-primary text-primary-foreground font-semibold rounded-lg hover:bg-primary/90 transition-all text-sm sm:text-base">
              {t("Get Started")}
            </button>
          </LeadFormDialog>
        </div>
      </div>
    </header>
  );
};
